import React from 'react';
import graph from '../graph';
import Update from '../Update';

import { FormattedMessage } from 'react-intl';
import { AvatarPopover, NewMediaPopup } from 'components';
import { Fade, Card, Stack, Typography, CardHeader, CardActions, CardActionArea } from '@mui/material';

export default function Model({ model, delay, checked, refetch, isAssign, selectable, handleSelect }) {
  const { id, title, media, attribute } = model;
  return (
    <>
      <Fade in unmountOnExit timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}>
        <Stack direction="row" alignItems="center">
          <Card
            sx={{
              width: '100%',
              position: 'relative',
              borderColor: checked && 'primary.main',
              bgcolor: checked && 'action.disabledBackground',
            }}
            variant="outlined"
          >
            <CardHeader
              sx={{ p: 1 }}
              avatar={
                <NewMediaPopup id={id} model="AttributeValue" collection="avatar" title={title} graph={graph}>
                  <AvatarPopover isAssign={isAssign} sx={{ width: 48, height: 48 }} media={media[0]?.full_url} />
                </NewMediaPopup>
              }
              title={
                <Stack rowGap={0.5} alignItems="flex-start">
                  <Typography variant="subtitle1">{title}</Typography>
                  <Typography variant="subtitle2">{attribute?.title}</Typography>
                </Stack>
              }
              action={<Typography variant="caption">{model.attribute?.category?.title}</Typography>}
            />
            <CardActions sx={{ justifyContent: 'flex-end' }}>
              <Update ids={id} title="update" refetch={refetch} />
            </CardActions>
            <CardActionArea
              sx={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                position: 'absolute',
              }}
              disabled={!isAssign && !selectable}
              onClick={handleSelect}
            />
          </Card>
        </Stack>
      </Fade>
    </>
  );
}
